import { makeStyles,useTheme } from '@material-ui/core/styles';

const useStyles = makeStyles(theme=> ({
  paper: {
    backgroundColor: '#FFF',
    border: '1px solid #E5E5E5',
    boxSizing: 'border-box',
    borderRadius: '3px',
    width: '600px',
    maxHeight: '644px',
    [theme.breakpoints.down('sm')]: {
      // width: '100%', 
      // maxWidth: '100%' 
    }
  },
  closeIcon: {
    fontSize: '17px',
    color: '#000'
  },
  closeBtn: {
    position: 'absolute',
    top: 0,
    right: 0,
    padding: '10px'
  },
  title: {
    fontSize: '15px',
    paddingBottom: '20px',
    padding: '40px 19px 20px',
    fontWeight: 'bold'
  },
  input: {
    width: '255px',
    [theme.breakpoints.down('sm')]: {
      width: '100%',
      paddingBottom: '25px', 
    }
  
  },
  formWrapper: {
    padding: '0px 20px'
  },
  actionsBtns: {
    marginTop: '20px',
    paddingTop: '20px',
    paddingBottom: '10px',
    borderTop: '1px solid #E5E5E5'
  },
  inlineInputs: {
    display: 'flex',
    paddingBottom: '25px',
    justifyContent: 'space-between',
    [theme.breakpoints.down('sm')]:{
      flexDirection:'column',
      paddingBottom: '0'
    }
  },
  inlineSwitch: {
    display: 'flex',
    fontSize: '10px',
    flexDirection: 'row'
  },
  inlineSwitchLabel: {
    flexDirection: 'row-reverse',
    textTransform: 'uppercase',
    marginLeft: '1px',
    color: '#071B27',
    lineHeight: '12px',
    marginBottom: '6px',
    letterSpacing: '0.035em',
    fontSize: '10px'
  },
  inputIndent: {
    paddingBottom: '25px'
  },
  checkbox: {
    margin: '-10px 0 40px'
  },
  helpIcon: {
    position: 'absolute',
    fontSize: '18px',
    top: '-1px',
    marginLeft: '6px'
  },
  selectBOButton: {
    border: '1px solid #0e8bb4',
    borderRadius: '3px',
    fontSize: '13px',
    lineHeight: '18px',
    fontWeight: 500,
    color: '#0e8bb4',
    padding: '8px 15px',
    minWidth: '80px',
    marginRight: '15px'
  }
}));

export default useStyles;
